// extracted by mini-css-extract-plugin
module.exports = {"card":"CardCaseStudy_card__7Rclo","text":"CardCaseStudy_text__3Pbkw","verticalcenter":"CardCaseStudy_verticalcenter__37XAd","tile":"CardCaseStudy_tile__Pmmou"};